import { render, staticRenderFns } from "./TourTableLight.vue?vue&type=template&id=0313be14&scoped=true"
import script from "./TourTableLight.vue?vue&type=script&lang=js"
export * from "./TourTableLight.vue?vue&type=script&lang=js"
import style0 from "./TourTableLight.vue?vue&type=style&index=0&id=0313be14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313be14",
  null
  
)

export default component.exports